const ENDPOINTS = {
  INVENTORY_LABEL_GENERATOR: '/inventory_label_generator',
  UPC_LABEL_GENERATOR: '/upc_label_generator',
};

export default ENDPOINTS;
